import { render, staticRenderFns } from "./ViewIdTag.vue?vue&type=template&id=4bcd2737&"
import script from "./ViewIdTag.vue?vue&type=script&lang=ts&"
export * from "./ViewIdTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports